<section class="info-panel">
  <header class="info-panel__header">{{ title | translate }}</header>
  <div class="info-panel__items">
    <!-- loop through gridData array and build each div-->
    <div *ngFor="let item of data" class="info-panel__item">
      <div class="info-panel__item__title">{{ item.header | translate }}</div>
      <div class="info-panel__item__value">{{ item.formattedValue }}</div>
    </div>
  </div>
  <div class="info-panel__footNote">
    {{footNote}}
  </div>
</section>
